export var HTTPS_KEY_LENGTH_OPTIONS = ['2048', '3072', '4096', '8192'];
// Form field validation constraints
export var CommonNameMaxLength = 128;
export var OrgUnitMaxLength = 128;
export var OrgFieldMaxLength = 128;
export var LocalityMaxLength = 128;
export var StateMaxLength = 128;
export var EmailMaxLength = 128;
export var PasswordMaxLength = 128;
